import React from "react";
export default function ExperienceConnect() {
  return (
    <footer className="experience-connect">
      <h2>Let’s discuss</h2>
      <p>
        To discuss these questions in more detail, connect with me on{" "}
        <a
          href="https://topmate.io/sainikkhaddar"
          target="_blank"
          rel="noopener noreferrer"
        >
          topmate.io
        </a>
        .
      </p>
      <p>
        Or follow and DM me on{" "}
        <a
          href="https://www.instagram.com/sainikkhaddar_/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Instagram — @sainikkhaddar_
        </a>
        .
      </p>
    </footer>
  );
}
